// mutations
export const BEGIN_AJAX_CALL = 'BEGIN_AJAX_CALL'
export const AJAX_CALL_ERROR = 'AJAX_CALL_ERROR'
export const AJAX_CALL_SUCCESS = 'AJAX_CALL_SUCCESS'

export const RECEIVE_COMPANY = 'RECEIVE_COMPANY'



// WEBPACK FOOTER //
// ./src/app/config/store/modules/company/types.js